import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import ActivityCard from "./activitycard/ActivityCard";
import Activity from "./Activity";
import { useFetch } from "../../services/hooks/useFetch";
import { apiPrefix } from "../../utils/main";
import { projectActivityLogs } from "../../models/Project";

interface ProjectActivityInput {
  onClose: () => void;
}

export default function ProjectActivity({ onClose }: ProjectActivityInput) {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const { fetch, data: logs } = useFetch<
    ActivityLogWithDate[],
    undefined,
    ActivityLog[]
  >();

  useEffect(() => {
    void fetch(`${apiPrefix}/projects/${projectId}/activity`, {
      responseManipulationFunction: (data: ActivityLog[]) => {
        return projectActivityLogs(data);
      },
    });
  }, [projectId, fetch]);

  return (
    <Activity title={"Project Activity"} onClose={onClose} logs={logs}>
      {(log: ActivityLogWithDate) => (
        <ActivityCard key={log.id} log={log} cardType={"project"} />
      )}
    </Activity>
  );
}
